import {
    Organisation,
    OrganisationInvoiceData,
    OrganisationSettingsInput,
    SubOrganisation
} from '@/api/klip-api.proxy';
import { organisationSettings } from '@/app/settings/settings-routes';
import {computed, defineComponent, onMounted, ref, watch} from 'vue';
import {useKlipApiProxy} from '@/plugins/proxy-client';
import {useRouter} from '@/router/router-vue3';
import {useForm} from 'vee-validate';
import {
    IKlInvoiceSettingsData,
    createInvoiceSettingsSchema
} from '@/app/shared/components/kl-invoice-settings/kl-invoice-settings';
import * as yup from 'yup';
import {toTypedSchema} from '@vee-validate/yup';
import {
    klValidationFields,
    ValidationFieldsType
} from '@/app/shared/components/kl-form-fields/kl-field-validation-util';
import OrganisationHelper from "@/app/shared/helpers/organisation-helper";

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlCreateSubOrganisation',
    props: {},
    setup(props) {

        const schema = yup.object({
            organisationName: yup.string().required().max(450).label('Naam organisatie'),
            organisationParentId: yup.string().required().label('Suborganisatie van'),
            hasInvoiceSettings: yup.boolean(),
            invoiceSettings: yup.object().when('hasInvoiceSettings', { is: true, then: schema => createInvoiceSettingsSchema() }),
        });

        const router = useRouter()

        const form = useForm({
            validationSchema: toTypedSchema(schema),
            initialValues: {
                hasInvoiceSettings: false,
            }
        });
        const fields: ValidationFieldsType<typeof schema> = klValidationFields<typeof schema>(schema);

        const organisationName = fields.organisationName.getValue<string>();
        const organisationParentId = fields.organisationParentId.getValue<string>();
        const hasInvoiceSettings = fields.hasInvoiceSettings.getValue<boolean>();

        const isSending = ref<boolean>(false);
        const isLoading = ref<boolean>(true);

        const disableSubmit = computed((): boolean => !form.meta.value.valid || !form.meta.value.dirty);

        const routeSettings = computed(() => {
            return organisationSettings;
        });

        const suborganisations = ref<SubOrganisation[]>([]);
        const invoiceData = ref<OrganisationInvoiceData>();

        const onUpdateInvoiceSettings = (data: IKlInvoiceSettingsData) => {
            invoiceData.value.email = data.email;
            invoiceData.value.attention = data.attention;
            invoiceData.value.reference = data.reference;
        }

        const setDepth = (depth: number, name: string) => {
            return OrganisationHelper.setDepth(depth, name);
        }

        const _submitForm = () => {
            isSending.value = true;
            const organisationInput = new OrganisationSettingsInput();
            organisationInput.organisation = new Organisation();
            organisationInput.organisation.name = organisationName.value;
            organisationInput.organisation.parentId = organisationParentId.value;

            if (invoiceData.value) {
                organisationInput.organisationInvoiceData = new OrganisationInvoiceData();
                organisationInput.organisationInvoiceData.attention = invoiceData.value.attention;
                organisationInput.organisationInvoiceData.reminderEmail = invoiceData.value.reminderEmail;
                organisationInput.organisationInvoiceData.reference = invoiceData.value.reference;
                organisationInput.organisationInvoiceData.vatNumber = invoiceData.value.vatNumber;
            }

            useKlipApiProxy().organisation_CreateOrganisation(organisationInput).then(async () => {
                await router.push({ name: routeSettings.value.name, hash: "#organisation" });
            }).finally(() => {
                isSending.value = false;
            });
        }

        onMounted(() => {
            useKlipApiProxy().organisation_LoadCreateOrganisationView().then((view) => {
                suborganisations.value = view.result.subOrganisations;
                invoiceData.value = view.result.invoiceData;
            }).finally(() => {
                isLoading.value = false;
            });
        });

        watch(invoiceData, (newValue) => {
            hasInvoiceSettings.value = !!newValue;
        }, { immediate: true, deep: true });

        const _onInvalidSubmit = (submittedValues) => {
            console.log('_onInvalidSubmit', submittedValues);
        }

        const onSubmit = form.handleSubmit(_submitForm, _onInvalidSubmit);

        return {
            organisationParentId,
            organisationName,
            isSending,
            isLoading,
            suborganisations,
            invoiceData,

            onUpdateInvoiceSettings,

            setDepth,
            onSubmit,
            disableSubmit,

            fields,
        }
    }
})
